import React, {useState} from 'react'
import { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css'

const Contact = () => {

    const [error, seterror] = useState(false);
    const [send, setsend] = useState(false);
    const [contact, setcontact] = useState(true);

    const form = useRef();

    const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_yfohl58', 'template_7gn0mbe', form.current, '3vhnksoCloOP-XZR7')
      .then((result) => {
          console.log(result.text);
          setsend(true)
          setcontact(false)
      }, (error) => {
          console.log(error.text);
          seterror(true)
          setcontact(false)
      });
      e.target.reset()
    };

    setTimeout ( () => {
        seterror(false)
        setcontact(true)
        setsend(false)
    }, 5000) 

  return (
    <section id='contact'>
        <div className='container'>
            <div className='titel'>
                <h2>Contact</h2>
                <h3>Contact</h3>
            </div>
            <div className='contact-wrapper'>
                <div className='contact-left'>
                    <p>you can trust that your project will be completed on time and in the most professional manner possible.</p>
                    <p>just let me know your soecific project needs, and i will respond as soon as possible.</p>
                    <h3>mail me at :</h3>
                    <p>charefmohcin123@gmail.com</p>
                </div>
                <div className='contact-right'>
                    <form ref={form} onSubmit={sendEmail} className={contact ? 'forma' : 'none'}>
                        <input type={Text} placeholder="Your name" name="user_name" id="name" />
                        <input type={'email'} placeholder="Your e-mail" id="email" name="user_email" />
                        <textarea rows={6} name="message" id="message" placeholder='Your project descreption' ></textarea>
                        <button type='submit'>Send</button>
                    </form>
                    <div className={error ? 'send' : 'none'}>
                        <img src='./assets/wrong.png' alt='' />
                        <h2>error</h2>
                    </div>
                    <div className={send ? 'send' : 'none'}>
                        <img src='./assets/correct.png' alt='' />
                        <h2>message send successfully</h2>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Contact